<script setup lang="ts">
import type { User } from "@/types";
import { computed } from "vue";

const props = withDefaults(
  defineProps<{
    user: Pick<User, "id" | "full_name">;
    size?: number;
  }>(),
  {
    size: 40,
  }
);

const colors = [
  "#a91616",
  "#9fc818",
  "#3357ff",
  "#009bac",
  "#ff3333",
  "#207d10",
  "#ff5733",
  "#8c33ff",
  "#ff8c33",
  "#7a3d30",
  "#00c694",
  "#97740a",
  "#9d0ea8",
];

const color = computed(() => {
  const userId = props.user.id || 0;
  return colors[userId % colors.length];
});

const letters = computed(() => {
  if (!props.user.full_name) return "";
  const nameParts = props.user.full_name.trim().split(" ");
  if (nameParts.length > 1) {
    return nameParts[0][0].toUpperCase() + nameParts[1][0].toUpperCase();
  } else {
    return nameParts[0].slice(0, 2).toUpperCase();
  }
});
</script>

<template>
  <el-avatar
    :size="size"
    :style="{ backgroundColor: color, flexShrink: 0 }"
    class="shadow-sm p-0"
  >
    <span
      class="text-light"
      :style="{
      fontSize: `${size! / 2}px`, 
    }"
      >{{ letters }}</span
    >
  </el-avatar>
</template>

<style lang="scss" scoped></style>
